import React from 'react';
import Input from '../componenti/input/Simple';
import InputProv from '../componenti/input/Provincia';

const Certificazione = ({
    text_cittadino,
    anteprima, 
    inputValues,
    handleOnChange,
    }) => {
    return (
        <>            
            <div style={{padding:'20px'}}>DICHIARA</div>
            di essere {text_cittadino} italiano secondo le risultanze del Comune di
            <Input
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='dicComune'
            />
            <InputProv
                anteprima={anteprima} 
                inputValues={inputValues}
                handleOnChange={handleOnChange}
                inputName='dicProvComune'
            />
        </>
        );
    }

export default Certificazione;